// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetOfferEventDateResponse

import { DateTimefromYmd } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetOfferEventDateApiResponse = {
	date: string;
	startMinutes: number;
	endMinutes: number;
};

export type WidgetOfferEventDate = {
	date: DateTime;
	startMinutes: number;
	endMinutes: number;
};

export function hydrateWidgetOfferEventDate(data: WidgetOfferEventDateApiResponse): WidgetOfferEventDate {
	return {
		...data,
		date: DateTimefromYmd(data.date)!,
	};
}